import EventBus from '@/eventBus.js'

export default {
  methods: {
    listenShapeUpdate() {
      EventBus.$on('update-shape-blocks', this.onUpdateShapeBlocks)
    },
    unListenShapeUpdate() {
      EventBus.$off('update-shape-blocks', this.onUpdateShapeBlocks)
    },
    onUpdateShapeBlocks(updatedBlocks) {
      const oldCanvasBlocks = JSON.parse(JSON.stringify(this.dataCanvasBlocks))
      const newCanvasBlocks = { ...oldCanvasBlocks }
      updatedBlocks.forEach((block) => {
        newCanvasBlocks[block.id] = {
          ...newCanvasBlocks[block.id],
          ...block,
        }
      })
      this.updateCanvasBlocks(newCanvasBlocks, this.slideActive.id)
      this.backupBlocks(oldCanvasBlocks, newCanvasBlocks, updatedBlocks)
    },
  },
}
